import * as React from 'react'
import { tagType } from '@/model/wine'
import resolveAssetURL from '@/utils/resolveAssetURL'

import {
  Container,
  Image,
  Label
} from './style'

const Item = ({ item }) => {
  const { url, alt, title } = item

  return (
    <Container>
      <Image loading='lazy' src={ resolveAssetURL(url) } alt={ alt } title={ title } />
      <Label>{ title }</Label>
    </Container>
  )
}

Item.propTypes = {
  item: tagType
}

export default Item
